import React, { useContext, useState, useEffect, useCallback } from "react";
import { Spinner, Table } from "react-bootstrap";
import "./hostlisting.css";
import LogbookAllList from "../Logbook/LogbookAllList";
import LogContext from "context/LogContext";
import InfiniteScroll from 'react-infinite-scroll-component';

const HostLogbookList = () => {
  const [loadingPros, setLoadingPros] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  let { getAllHostLogbook, allLogbookNext, allLogbook } = useContext(LogContext);

  // Fetch more data for infinite scroll (scoped to this tab container)
  const fetchMoreData = useCallback(() => {
    if (!hasMore || loadingPros || !allLogbookNext) return;
    setLoadingPros(true);
    const res = getAllHostLogbook(new URL(allLogbookNext).search, true); // Pass true to append data
    res.then(() => {
      setLoadingPros(false);
      // If no next step after loading, set hasMore to false
      if (!allLogbookNext) {
        setHasMore(false);
      }
    }).catch(() => {
      setLoadingPros(false);
    });
  }, [hasMore, loadingPros, allLogbookNext, getAllHostLogbook]);

  const getAllLogbook = () => {
    if (allLogbook?.length === 0 && !loadingPros) {
      return (
        <tr>
          <td colSpan="4">No Data to show !</td>
        </tr>
      );
    } else if (allLogbook) {
      const logbookRows = allLogbook?.map((logbook) => {
        return <LogbookAllList key={logbook.id} log={logbook} />;
      });

      // Add loading spinner at the end when loading more
      if (loadingPros && allLogbook && allLogbook.length > 0) {
        logbookRows.push(
          <tr key="loading">
            <td colSpan="4">
              <div className="d-flex justify-content-center py-3">
                <Spinner animation="grow" />
                <Spinner animation="grow" />
                <Spinner animation="grow" />
              </div>
            </td>
          </tr>
        );
      }

      return logbookRows;
    } else {
      return (
        <tr>
          <td colSpan="4">No Data to show !</td>
        </tr>
      );
    }
  };

  return (
    <div>
      <div id="logbookScrollableDiv" style={{ height: '600px', overflow: 'auto' }}>
        <InfiniteScroll
          dataLength={allLogbook?.length || 0}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            loadingPros && allLogbook?.length > 0 && (
              <div className="d-flex justify-content-center py-3">
                <Spinner animation="grow" />
                <Spinner animation="grow" />
                <Spinner animation="grow" />
              </div>
            )
          }
          scrollableTarget="logbookScrollableDiv"
          endMessage={
            <div className="text-center py-3 text-muted">
              {!hasMore && allLogbook?.length > 0 && "You have seen all logbook entries!"}
            </div>
          }
        >
        <Table className="table-store" responsive>
          <thead>
            <tr>
              <th scope="col">
                <div className="arrows">Real Customer</div>
              </th>
              <th scope="col">
                <div className="arrows">Notes</div>
              </th>
              <th scope="col">
                <div className="arrows">Created At</div>
              </th>
              <th scope="col">
                <div className="arrows"> Commentor </div>
              </th>
            </tr>
          </thead>
          <tbody>{getAllLogbook()}</tbody>
        </Table>
        </InfiniteScroll>
      </div>
      
      {/* Show loading spinner for initial load */}
      {loadingPros && (!allLogbook || allLogbook.length === 0) && (
        <div className="d-flex justify-content-center py-4">
          <Spinner animation="grow" />
          <Spinner animation="grow" />
          <Spinner animation="grow" />
        </div>
      )}
    </div>
  );
};

export default HostLogbookList;